import { render } from "./index.vue?vue&type=template&id=470ffe0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=470ffe0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-470ffe0a"

export default script